import React, { useState, useEffect, useCallback, useRef } from "react";
import _ from "lodash";
import LoadingOverlay from "react-loading-overlay";
import Loader from "../../common/components/Loader";
import Portal from "../../common/components/Portal";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import ImageMasterModal from "../../common/components/ImageMasterModal";
import ImageMain from "../../common/components/ImageComponents/ImageMain";
import SingleImageUpdateModal from "../../common/components/ImageComponents/SingleImageUpdateModal";
import ImageForm from "../../common/components/ImageComponents/ImageForm";
import { useDispatch, useSelector } from "react-redux";
import actions from "../actions";
import { useParams, useHistory } from "react-router-dom";
import ImageViewModal from "../../images/components/ImageViewModal";
import {
    checkPermission,
    findInfoPathFromBreadCrump,
    findPrevPathFromBreadCrumpData,
    popBreadCrumpOnPageClose,
    showAlert as showAlertUtil
} from "../../../config/utils";
import { entities } from "../../common/constants";
import imageActions from "../../images/actions";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import qs from "query-string";
import { useClipboard } from "../../common/components/ImageComponents/ImageClipboardProvider";
import { ERROR_COPY } from "../../../config/errorMessages";

const InfoImages = ({
    isReportImage,
    checkIfNarrativeImageUsed,
    uploadImages,
    deleteImage,
    handleAssignImagesFromMaster,
    updateImageComment,
    refreshinfoDetails,
    closeInfoPage,
    hasPullFromMasterImages,
    showInfoPage,
    isRecommendation,
    isBuildingLocked,
    locked,
    isDeleted,
    hasEdit = true,
    hasDelete = true,
    hasCreate = true,
    imagesNotUsed = [],
    basicDetails,
    entity,
    isAsset = true,
    isRecomentaionView,
    deleteImageRecomention,
    noCheckbox,
    isMobileRecommendation = false,
    mobileRecommendationId,
    isCompletedAsset = false,
    surveyAssetClientId,
    isInaccessible = false,
    isSurveyStandards = false,
    isGlobalStandards = false,
    isSurveyUniformat = false,
    isGlobalUniformat = false,
    isMobRecom = false,
    isMobileRegularRecom = false,
    isMobileAsset = false,
    levelNumber = null
}) => {
    const query = qs.parse(useLocation()?.search);
    const dispatch = useDispatch();
    const history = useHistory();
    const assignRef = useRef(null);
    const { id, subTab } = useParams();
    const [showDeleteConfirmation, setDeleteConfirmation] = useState(false);
    const [bulkDeleteConfirmation, setBulkDeleteConfirmation] = useState(false);
    const [imageState, setImageState] = useState({
        uploadAttachmentsHeader: "Add",
        uploadAttachment: [],
        uploadError: "",
        fileChanged: false,
        showImagesModal: false,
        isLoading: false,
        showImageModal: false,
        imageList: [],
        selectedImage: "",
        showWarningModal: false,
        clickedImage: {},
        showImageMasterModal: false,
        totalCount: 0,
        imageParams: {
            limit: 40,
            offset: 1
        },
        hasMore: false,
        showSingleImageEditModal: false,
        showConfirmModal: false,
        alertMessage: "",
        isFetchMore: false
    });

    const updateCommentRef = useRef(null);
    const updateDeleteRef = useRef(null);

    const {
        getSurveyAssetImagesById,
        updateAssetImageCommentResponse,
        getSurveyRecommendationsImagesById,
        defaultImageLoading,
        deleteImageLoading,
        deleteImageResponse,
        getStandardImagesById
    } = useSelector(state => state.assetSurveyProjectReducer);

    const { assignImageResponse, imageUpdateResponse } = useSelector(state => state.imageReducer);
    const paramId = qs.parse(useLocation()?.search)?.id || "";

    const refreshImageList = useCallback(
        async (isFetchMore = false) => {
            if (!isFetchMore) {
                setImageState(prevState => ({ ...prevState, isLoading: true, hasMore: false, imageParams: { ...prevState.imageParams, offset: 1 } }));
            }
            if (!isRecommendation) {
                if (isSurveyStandards || isGlobalStandards || isSurveyUniformat || isGlobalUniformat) {
                    dispatch(
                        actions.getStandardImagesById(
                            isSurveyStandards || isSurveyUniformat ? paramId : id,
                            isSurveyStandards
                                ? "survey-standard-image"
                                : isSurveyUniformat
                                  ? "survey-uniformat-image"
                                  : isGlobalUniformat
                                    ? "global-uniformat-image"
                                    : "global-standard-image",
                            levelNumber ? { uniformat_leaf_level: levelNumber, uniformat_level_id: id } : {}
                        )
                    );
                } else dispatch(actions.getSurveyAssetImagesById(id, subTab));
            } else
                dispatch(
                    actions.getSurveyRecommendationImagesById(
                        mobileRecommendationId ?? id,
                        isMobileRegularRecom ? { view_from: "recommendation" } : {}
                    )
                );
        },
        [id]
    );

    useEffect(() => {
        return () => {
            dispatch(actions.resetReducer(isSurveyStandards || isGlobalStandards || isSurveyUniformat || isGlobalUniformat ? "standards" : "image"));
            (isSurveyStandards || isGlobalStandards || isSurveyUniformat || isGlobalUniformat) && dispatch(actions.resetImageReducer());
        };
    }, []);

    useEffect(() => {
        if (assignImageResponse && assignRef?.current) {
            if (assignImageResponse?.success) {
                setImageState(prevState => ({
                    ...prevState,
                    alertMessage: "Image(s) assigned successfully"
                }));
                showAlert();
                refreshImageList();
            } else {
                setImageState(prevState => ({
                    ...prevState,
                    alertMessage: typeof assignImageResponse?.detail === "string" ? assignImageResponse?.detail : ERROR_COPY.GENERIC
                }));
                showAlert();
            }
            assignRef.current = false;
        }
    }, [assignImageResponse]);

    useEffect(() => {
        if (getSurveyAssetImagesById) {
            setImageState({ ...imageState, isLoading: false });
            if (getSurveyAssetImagesById?.data?.image || getSurveyAssetImagesById?.data?.added_image) {
                const images = [...(getSurveyAssetImagesById?.data?.image ?? []), ...(getSurveyAssetImagesById?.data?.added_image ?? [])];
                setImageState(prevState => ({
                    ...prevState,
                    imageList: imageState.isFetchMore ? [...prevState.imageList, ...images] : images,
                    totalCount: getSurveyAssetImagesById?.data?.image_count + getSurveyAssetImagesById?.data?.added_image_count,
                    isLoading: false,
                    hasMore: false
                }));
            } else {
                setImageState(prevState => ({
                    ...prevState,
                    imageList: [],
                    totalCount: 0,
                    isLoading: false,
                    hasMore: false
                }));
            }
        }
    }, [getSurveyAssetImagesById]);
    useEffect(() => {
        if (getStandardImagesById && (isGlobalStandards || isSurveyStandards || isSurveyUniformat || isGlobalUniformat)) {
            setImageState({ ...imageState, isLoading: false });
            if (getStandardImagesById?.data?.image || getStandardImagesById?.data?.added_image) {
                const images = [...(getStandardImagesById?.data?.image ?? []), ...(getStandardImagesById?.data?.added_image ?? [])];
                setImageState(prevState => ({
                    ...prevState,
                    imageList: imageState.isFetchMore ? [...prevState.imageList, ...images] : images,
                    totalCount: getStandardImagesById?.data?.image_count + (getStandardImagesById?.data?.added_image_count ?? 0),
                    isLoading: false,
                    hasMore: false
                }));
            } else {
                setImageState(prevState => ({
                    ...prevState,
                    imageList: [],
                    totalCount: 0,
                    isLoading: false,
                    hasMore: false
                }));
            }
        }
    }, [getStandardImagesById]);
    useEffect(() => {
        if (getSurveyRecommendationsImagesById) {
            setImageState({ ...imageState, isLoading: false });
            if (getSurveyRecommendationsImagesById?.data) {
                const originalImages = (getSurveyRecommendationsImagesById.data.image ?? []).map(img => ({
                    ...img,
                    upload_type: "survey_image_upload"
                }));
                const newImages = (getSurveyRecommendationsImagesById.data.added_image ?? []).map(img => ({ ...img, upload_type: "image_upload" }));
                const images = [...originalImages, ...newImages];
                setImageState(prevState => ({
                    ...prevState,
                    imageList: prevState.isFetchMore ? [...prevState.imageList, ...images] : images,
                    totalCount:
                        (getSurveyRecommendationsImagesById?.data?.image_count ?? 0) +
                        (getSurveyRecommendationsImagesById?.data?.added_image_count ?? 0),
                    isLoading: false,
                    hasMore: false
                }));
            } else {
                setImageState(prevState => ({
                    ...prevState,
                    imageList: [],
                    totalCount: 0,
                    isLoading: false,
                    hasMore: false
                }));
            }
        }
    }, [getSurveyRecommendationsImagesById]);
    useEffect(() => {
        if (updateCommentRef?.current && imageUpdateResponse && isMobRecom) {
            updateCommentRef.current = false;
            const { success, message = "", detail = null, error = null } = imageUpdateResponse;
            if (success) {
                setImageState({ ...imageState, alertMessage: "Image updated successfully" });
            } else {
                setImageState({ ...imageState, alertMessage: detail ? detail : message ? message : error });
            }
            refreshImageList();
        }
    }, [imageUpdateResponse]);

    useEffect(() => {
        if (updateCommentRef?.current && updateAssetImageCommentResponse) {
            updateCommentRef.current = false;
            const { success, message = "", detail = null, error = null } = updateAssetImageCommentResponse;
            if (success) {
                setImageState({ ...imageState, alertMessage: "Survey asset image updated successfully" });
            } else {
                setImageState({ ...imageState, alertMessage: detail ? detail : message ? message : error });
            }
            refreshImageList();
        }
    }, [updateAssetImageCommentResponse]);

    useEffect(() => {
        if (updateDeleteRef?.current && deleteImageResponse) {
            updateDeleteRef.current = false;
            const { success, message = "", detail = null, error = null } = deleteImageResponse;
            if (success) {
                setImageState({
                    ...imageState,
                    alertMessage:
                        isSurveyStandards || isGlobalStandards || isSurveyUniformat || isGlobalUniformat || isMobRecom
                            ? "Image(s) deleted successfully"
                            : "Survey asset image deleted successfully"
                });
            } else {
                setImageState({ ...imageState, alertMessage: detail ? detail : message ? message : error });
            }
        }
    }, [deleteImageResponse]);

    useEffect(() => {
        if (id || mobileRecommendationId) {
            refreshImageList();
        }
    }, [id, imageState?.imageParams?.limit, imageState?.imageParams?.offset, mobileRecommendationId]);

    useEffect(() => {
        if (imageState?.alertMessage) {
            showAlert();
            setImageState({ ...imageState, alertMessage: "" });
        }
    }, [imageState.alertMessage]);

    const fetchMoreImages = () => {
        const { imageParams } = imageState;
        setImageState(prevState => ({
            ...prevState,
            imageParams: { ...imageParams, offset: imageParams.offset + 1 }
        }));
    };

    const handleLimitChange = value => {
        setImageState(
            prevState => ({
                ...prevState,
                imageParams: {
                    ...prevState.imageParams,
                    offset: 1,
                    limit: value
                }
            }),
            () => {
                refreshImageList();
            }
        );
    };

    const toggleImagesModal = () => {
        setImageState(prevState => ({
            ...prevState,
            showImagesModal: !prevState.showImagesModal
        }));
    };

    const defaultImageHandler = async (item, state) => {
        setImageState(prevState => ({
            ...prevState,
            isLoading: true
        }));
        const param = {
            id: item.id,
            description: item.description,
            default: state
        };
        await updateImage(param);
    };

    const setPrintableImage = async (item, state) => {
        setImageState(prevState => ({
            ...prevState,
            isLoading: true
        }));
        const param = {
            id: item.id,
            description: item.description,
            printable: state
        };
        await updateImage(param);
    };

    const checkIfNarrativeImageUsedHandler = (item, state) => {
        if (state === true) {
            setPrintableImage(item, state);
        } else {
            let usedImgFound = false;
            let narrativeCompleted = false;
            if (isReportImage) {
                usedImgFound = checkIfNarrativeImageUsed(item.id);
                narrativeCompleted = narrativeCompleted;
            }
            if (usedImgFound) {
                setImageState({ clickedImage: { item, state, narrativeCompleted }, showWarningModal: true });
            } else {
                setPrintableImage(item, state);
            }
        }
    };

    const openImageModal = () => {
        setImageState(prevState => ({
            ...prevState,
            showImageModal: true
        }));
    };

    const closeImageModal = () => {
        setImageState(prevState => ({
            ...prevState,
            showImageModal: false
        }));
    };

    const uploadImagesHandler = async imageData => {
        setImageState(prevState => ({
            ...prevState,
            isloading: true
        }));
        await uploadImages(imageData);
        await refreshImageList();
    };

    const deleteImageHandler = async imageId => {
        setImageState(prevState => ({
            ...prevState,
            isloading: true
        }));
        await deleteImage(imageId);
        await refreshImageList();
    };

    const handleAssignImages = async imgData => {
        assignRef.current = true;
        setImageState(prevState => ({
            ...prevState,
            isloading: true
        }));
        dispatch(
            imageActions.assignImagesToSection(
                {
                    image_upload_ids: imgData?.images?.map(e => e?.id),
                    ...(isSurveyStandards
                        ? { client_standard_id: query?.id }
                        : isGlobalStandards
                        ? { client_standard_id: id }
                        : isSurveyUniformat
                        ? { uniformat_level_6_id: query?.id }
                        : isGlobalUniformat
                        ? { uniformat_level_6_id: id }
                        : isMobRecom
                        ? { recommendation_id: id ?? query?.s_id }
                        : { mobile_asset_id: id }),
                    ...(isInaccessible && { mobile_asset_type: "inaccessible_asset" }),
                    ...((isSurveyStandards || isGlobalStandards || isSurveyUniformat || isGlobalUniformat) && {
                        source: isSurveyStandards || isSurveyUniformat ? "survey" : "global"
                    }),
                    ...(isSurveyStandards || isSurveyUniformat ? { asset_survey_project_id: id } : {}),
                    ...(levelNumber ? { uniformat_leaf_level: levelNumber } : {})
                },
                null,
                isSurveyStandards || isGlobalStandards
                    ? "client-standards-images"
                    : isSurveyUniformat || isGlobalUniformat
                      ? "uniformat-standard_images"
                      : isMobRecom
                        ? "mobile-recom-image"
                        : "adc-asset-image"
            )
        );
    };

    const showAlert = () => showAlertUtil(imageState.alertMessage);

    const updateImage = async imageData => {
        setImageState(prevState => ({
            ...prevState,
            isloading: true
        }));
        updateCommentRef.current = true;
        await updateImageComment(imageData);
    };

    const setSelectedImage = async img => {
        setImageState(prevState => ({
            ...prevState,
            selectedImage: img
        }));
        openImageModal();
    };

    const renderUsedImageWarning = () => {
        const {
            showWarningModal,
            clickedImage: { item, state, narrativeCompleted }
        } = imageState;
        if (!showWarningModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Do you really want to disable ?"}
                        message={
                            narrativeCompleted
                                ? `The narrative is marked as complete & the image is already used in narrative. Disabled image will be removed from the narrative & this action will mark the narrative as incomplete.`
                                : "This image is already used in narrative, Disabled image will be removed from the narrative."
                        }
                        onNo={() => setImageState(prevState => ({ ...prevState, showWarningModal: false }))}
                        onYes={() => {
                            setImageState(prevState => ({ ...prevState, showWarningModal: false }));
                            setPrintableImage(item, state);
                        }}
                    />
                }
                onCancel={() => setImageState(prevState => ({ ...prevState, showWarningModal: false }))}
            />
        );
    };

    const toggleMasterImageModal = () => {
        setImageState(prevState => ({
            ...prevState,
            showImageMasterModal: !prevState.showImageMasterModal
        }));
    };

    const handleEdit = async item => {
        setImageState(prevState => ({
            ...prevState,
            showImagesModal: true,
            selectedImage: item
        }));
    };

    const handleNext = id => {
        let current_index = imageState.imageList?.findIndex(item => item.id === id);
        let selectedImage = imageState.imageList[current_index + 1];
        setSelectedImage(selectedImage);
    };

    const handlePrev = id => {
        let current_index = imageState.imageList?.findIndex(item => item.id === id);
        let selectedImage = imageState.imageList[current_index - 1];
        setSelectedImage(selectedImage);
    };

    const renderSingleImageEditModal = () => {
        const { showSingleImageEditModal, selectedImage } = imageState;
        if (!showSingleImageEditModal) return null;
        return (
            <Portal
                body={
                    <SingleImageUpdateModal
                        entity={entity}
                        imagesNotUsed={imagesNotUsed}
                        onCancel={() =>
                            setImageState(prevState => ({
                                ...prevState,
                                showSingleImageEditModal: false,
                                selectedImage: {}
                            }))
                        }
                        image={selectedImage}
                        updateImageData={updateImage}
                    />
                }
                onCancel={() => setImageState(prevState => ({ ...prevState, showSingleImageEditModal: false }))}
            />
        );
    };

    const editFunction = (editedData, editedImages) => {
        editedImages.forEach(({ id }) => {
            setImageState(prevState => {
                const imageList = prevState.imageList.map(item => {
                    if (item.id === id) {
                        item.image_labels = editedData?.image_labels;
                        item.image_text = editedData?.image_text;

                        return item;
                    } else return item;
                });

                const selectedImage = { ...prevState.selectedImage, image_labels: editedData?.image_labels, image_text: editedData?.image_text };

                return { ...imageState, imageList, selectedImage };
            });
        });
    };

    const renderImageModal = () => {
        const { showImageModal, selectedImage } = imageState;
        if (!showImageModal) return null;
        return (
            <Portal
                body={
                    <ImageViewModal
                        imageList={imageList}
                        selectedImg={selectedImage}
                        handleNext={handleNext}
                        handlePrev={handlePrev}
                        onCancel={closeImageModal}
                        hasNextPrev={imageList.length > 1}
                        isRecommendationView
                        isSurveyAssetView
                        hasEditButton
                        updateImageFromSurveyAsset={updateImage}
                        handleInputCaptionData={handleInputCaptionData}
                        editFunction={editFunction}
                        isSurveyAssetImage={!isMobRecom}
                        isAssignedAssetImage={getSurveyAssetImagesById?.data?.added_image?.some(e => e?.id === selectedImage?.id)}
                        hasCaptionEdit={!mobileRecommendationId}
                        isMobRecom={isMobRecom}
                        isMobileRegularRecom={isMobileRegularRecom ?? false}
                        hasEdit={isMobRecom}
                        handleEdit={handleEdit}
                        hasExport={checkPermission("forms", "image_management", "export")}
                    />
                }
                onCancel={closeImageModal}
            />
        );
    };

    const renderMasterImageModal = () => {
        const { showImageMasterModal } = imageState;
        if (!showImageMasterModal) return null;
        let formattedBasicDetails = {};
        Object.values(basicDetails ?? {}).forEach(value => {
            Object.keys(value || {}).forEach(eachKey => {
                if (["region_id", "site_id", "building_id", "project_id"].includes(eachKey) && value?.[eachKey]?.uuid && isMobRecom) {
                    const field = {
                        region_id: "region",
                        site_id: "site",
                        building_id: "building",
                        project_id: "project_id"
                    };
                    formattedBasicDetails = {
                        ...formattedBasicDetails,
                        [field?.[eachKey]]: { id: value?.[eachKey]?.uuid },
                        client: { id: query?.c_id || "" }
                    };
                } else if (["assets.region_id", "assets.site_id", "assets.building_id"].includes(eachKey) && value?.[eachKey]?.uuid) {
                    const field = {
                        "assets.region_id": "region",
                        "assets.site_id": "site",
                        "assets.building_id": "building"
                    };
                    formattedBasicDetails = { ...formattedBasicDetails, [field?.[eachKey]]: { id: value?.[eachKey]?.uuid } };
                }
            });
        });
        return (
            <Portal
                body={
                    <ImageMasterModal
                        AssetName={basicDetails?.asset?.asset_name}
                        basicDetails={{ client: { id: surveyAssetClientId }, ...formattedBasicDetails }}
                        entity={entities.ASSET_MANAGEMENT}
                        hasPullFromMasterImages={hasPullFromMasterImages}
                        onCancel={() =>
                            setImageState(prevState => ({
                                ...prevState,
                                showImageMasterModal: false
                            }))
                        }
                        handleAssignImages={handleAssignImages}
                        isAsset={!isMobileRecommendation}
                        surveyAssetClientId={surveyAssetClientId}
                        isSurveyAsset
                        isInaccessible={isInaccessible}
                        isStandardImage={isGlobalStandards || isSurveyStandards || false}
                        isGlobalStandards={isGlobalStandards}
                        isSurveyUniformat={isSurveyUniformat || false}
                        isGlobalUniformat={isGlobalUniformat}
                        imageListValue={imageList || []}
                        isMobRecom={isMobRecom}
                        mobileRecommendationId={mobileRecommendationId}
                        levelNumber={levelNumber ?? null}
                    />
                }
                onCancel={() =>
                    setImageState(prevState => ({
                        ...prevState,
                        showImageMasterModal: false
                    }))
                }
            />
        );
    };

    const cancelConfirmModal = () => {
        setImageState(prevState => ({
            ...prevState,
            showConfirmModal: false
        }));
    };

    const renderConfirmationModal = () => {
        const { showConfirmModal, alertMessage } = imageState;
        if (!showConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Are you sure?"}
                        message={alertMessage}
                        onCancel={cancelConfirmModal}
                        onNo={cancelConfirmModal}
                        onYes={cancelConfirmModal}
                    />
                }
                onCancel={cancelConfirmModal}
            />
        );
    };

    const renderImageForm = () => {
        const { uploadAttachmentsHeader, uploadAttachment, uploadError, fileChanged, showImagesModal, selectedImage } = imageState;
        if (!showImagesModal) return null;
        return (
            <Portal
                body={
                    <ImageForm
                        header={uploadAttachmentsHeader}
                        toggleImagesModal={toggleImagesModal}
                        uploadImages={uploadImagesHandler}
                        uploadAttachment={uploadAttachment}
                        uploadError={uploadError}
                        fileChanged={fileChanged}
                        setImageList={refreshImageList}
                        closeInfoPage={closeInfoPage}
                        images={selectedImage}
                        onCancel={toggleImagesModal}
                        isSurveyAsset
                        refreshImageList={refreshImageList}
                        isAssignedAssetImage={getSurveyAssetImagesById?.data?.added_image?.some(e => e?.id === selectedImage?.id)}
                        isMobileRecommendation={isMobileRecommendation}
                    />
                }
                onCancel={toggleImagesModal}
            />
        );
    };

    const handleInputCaptionData = async caption => {
        let caption_id = caption?.id ?? caption?.image_ids[0];
        if (caption_id) {
            setImageState(prevState => {
                const imageList = prevState.imageList.map(item => {
                    if (item.id === caption_id) {
                        item.caption = caption?.description ?? caption?.caption;
                        return item;
                    } else return item;
                });
                const selectedImage = { ...prevState.selectedImage, caption: caption?.description ?? caption?.caption };
                return { ...prevState, imageList, selectedImage };
            });
        }
    };

    const handleSelectImage = image => {
        dispatch(
            actions.defaultImageUpdate(
                image?.id,
                isMobRecom ? id || query?.s_id : id,
                isMobileRecommendation || isMobRecom,
                () => refreshImageList(),
                isInaccessible,
                isMobileRegularRecom ? { view_from: "recommendation" } : {}
            )
        );
    };

    const handleDelete = image => {
        setDeleteConfirmation(image);
    };
    const handleBulkDelete = image => {
        setBulkDeleteConfirmation(image);
        setDeleteConfirmation((image ?? [])?.map(e => e?.id) ?? []);
    };
    const renderDeleteConfirmationModal = () => {
        if (!showDeleteConfirmation) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={
                            isSurveyStandards || isGlobalStandards ? (
                                "Do you want to remove this image from this client standard?"
                            ) : isSurveyUniformat || isGlobalUniformat ? (
                                "Do you want to remove this image from this uniformat level 6?"
                            ) : bulkDeleteConfirmation?.length > 1 ? (
                                <>
                                    Do you want to remove{" "}
                                    {bulkDeleteConfirmation?.length ? (
                                        <span
                                            className="badge-red-circled pl-2 pr-2 m-0"
                                            style={{ minWidth: "20px", maxWidth: "100px", width: "auto" }}
                                        >
                                            {bulkDeleteConfirmation?.length || ""}
                                        </span>
                                    ) : (
                                        "all"
                                    )}{" "}
                                    images from this Recommendation?
                                </>
                            ) : isMobRecom ? (
                                "Do you want to remove this image from this Recommendation?"
                            ) : (
                                "Do you want to remove this image from this survey asset?"
                            )
                        }
                        message={"This action cannot be reverted, are you sure that you need to remove this image?"}
                        onNo={() => setDeleteConfirmation(false)}
                        onYes={() => {
                            updateDeleteRef.current = true;
                            dispatch(
                                actions.handleDelete(
                                    {
                                        image_ids: bulkDeleteConfirmation ? showDeleteConfirmation : [showDeleteConfirmation],
                                        delete_from:
                                            getSurveyRecommendationsImagesById?.data?.added_image?.some(e => e?.id === showDeleteConfirmation) &&
                                            isMobRecom
                                                ? "mobile_recom"
                                                : isMobileRecommendation || isMobRecom
                                                  ? "survey_recomm"
                                                  : getSurveyAssetImagesById?.data?.added_image?.some(e => e?.id === showDeleteConfirmation)
                                                    ? "mobile_asset"
                                                    : isSurveyStandards || isSurveyUniformat
                                                      ? "survey"
                                                      : isGlobalStandards || isGlobalUniformat
                                                        ? "global"
                                                        : "survey_asset",
                                        ...(isGlobalStandards || isSurveyStandards ? { client_standard_id: isGlobalStandards ? id : query?.id } : {}),
                                        ...(isGlobalUniformat || isSurveyUniformat ? { uniformat_level_id: isGlobalUniformat ? id : query?.id } : {}),
                                        ...(isMobRecom ? { recommendation_id: id ?? query?.s_id } : {}),
                                        ...(isMobileRegularRecom ? { view_from: "recommendation" } : {}),
                                        ...(isMobileAsset ? { mobile_asset_id: id } : {}),
                                        ...(levelNumber ? { uniformat_leaf_level: levelNumber } : {})
                                    },
                                    isMobileRecommendation || isMobRecom,
                                    () => {
                                        refreshImageList();
                                        setDeleteConfirmation(false);
                                        setBulkDeleteConfirmation(false);
                                    },
                                    isSurveyStandards || isGlobalStandards
                                        ? "client-standards"
                                        : isGlobalUniformat || isSurveyUniformat
                                          ? "uniformat-standard_images"
                                          : ""
                                )
                            );
                        }}
                        type={isMobRecom || isMobileAsset ? "remove" : ""}
                        isSurveyImage={!isMobRecom && !isMobileAsset}
                    />
                }
                onCancel={() => setDeleteConfirmation(false)}
            />
        );
    };

    const { isLoading, imageList, hasMore, imageParams } = imageState;

    const { clip } = useClipboard();
    const hasClipboard = !!clip.sourceEntityId && clip.itemIds?.length > 0;
    const sameClient = clip.clientId && clip.clientId === query?.c_id;
    const canPaste = hasClipboard && sameClient && !(clip.sourceEntityId === id && clip.clientId === query?.c_id);

    return (
        <LoadingOverlay active={isLoading || defaultImageLoading || deleteImageLoading} spinner={<Loader />}>
            <div
                className={`tab-active ${mobileRecommendationId ? "" : "location-sec img-dt"} img-dt images-overlay flex-column img-assign-view ${
                    isMobRecom ? "pt-1" : ""
                }`}
            >
                <div className="btn-edit-otr btn-main-outr">
                    <div className="text-label"></div>
                    <div className="image-wrapper-btn-icon d-flex">
                        {((isCompletedAsset && hasCreate) ||
                            isInaccessible ||
                            ((isSurveyStandards || isGlobalStandards || isSurveyUniformat || isGlobalUniformat || isMobRecom) && hasCreate)) && (
                            <button className="addLoc" onClick={toggleMasterImageModal}>
                                <i className="fas fa-file-import mr-2"></i>
                                {isSurveyStandards || isGlobalStandards || isSurveyUniformat || isGlobalUniformat
                                    ? "Assign From Gallery"
                                    : "Assign From Gallery/ Upload New Images"}
                            </button>
                        )}
                        {!mobileRecommendationId && (
                            <span
                                onClick={() => {
                                    const currentBreadCrumbData = findInfoPathFromBreadCrump();
                                    if (currentBreadCrumbData?.length && currentBreadCrumbData?.[currentBreadCrumbData?.length - 1]?.isFromTable) {
                                        popBreadCrumpOnPageClose();
                                    }
                                    popBreadCrumpOnPageClose();
                                    history.push(findPrevPathFromBreadCrumpData());
                                }}
                                className="edit-icn-bx"
                            >
                                <i className="fas fa-window-close"></i> Close
                            </span>
                        )}
                    </div>
                </div>

                <div className={`image-sec ${mobileRecommendationId ? "" : "pt-3"}`}>
                    <div className={`col ${mobileRecommendationId ? "p-0" : ""}`}>
                        <div className="outer-sldr">
                            <div className="sld-rgt">
                                {imageList?.length || canPaste ? (
                                    <>
                                        <ImageMain
                                            openImageModal={openImageModal}
                                            openImageMasterModal={toggleMasterImageModal}
                                            handleLimitChange={handleLimitChange}
                                            handleNext={handleNext}
                                            handlePrev={handlePrev}
                                            imageList={imageList}
                                            hasMore={hasMore}
                                            imageParams={imageParams}
                                            fetchMoreImages={fetchMoreImages}
                                            showInfoPage={showInfoPage}
                                            closeInfoPage={closeInfoPage}
                                            basicDetails={basicDetails}
                                            isRecommendation={isRecommendation}
                                            isAsset={isAsset}
                                            isRecomentaionView={isRecomentaionView}
                                            deleteImageRecomention={deleteImageRecomention}
                                            handleClickImage={setSelectedImage}
                                            totalCount={imageState?.totalCount}
                                            handleInputCaptionData={handleInputCaptionData}
                                            updateImage={updateImage}
                                            isSurveyAssetImage
                                            refreshImageList={refreshImageList}
                                            isMobileRecommendation={isMobileRecommendation}
                                            hasEdit={
                                                isSurveyStandards ||
                                                isGlobalStandards ||
                                                isSurveyUniformat ||
                                                isGlobalUniformat ||
                                                isMobileRegularRecom
                                                    ? false
                                                    : hasEdit
                                            }
                                            hasCaptionEdit={!mobileRecommendationId}
                                            hasCheckBox={
                                                !isInaccessible &&
                                                !isSurveyStandards &&
                                                !isGlobalStandards &&
                                                !isSurveyUniformat &&
                                                !isGlobalUniformat &&
                                                !isMobileRegularRecom
                                            }
                                            handleSelectImage={handleSelectImage}
                                            hasDelete={
                                                isMobileRecommendation || (isMobRecom && !isMobileRegularRecom)
                                                    ? true
                                                    : isSurveyStandards || isGlobalStandards || isSurveyUniformat || isGlobalUniformat
                                                      ? hasDelete
                                                      : isCompletedAsset && hasDelete
                                            }
                                            handleDelete={handleDelete}
                                            handleEdit={handleEdit}
                                            isMobRecom={isMobRecom ?? false}
                                            isMobileRegularRecom={isMobileRegularRecom ?? false}
                                            hasCaptionOnly={mobileRecommendationId ?? false}
                                            onBulkDelete={handleBulkDelete}
                                            hasBulkDelete={isMobRecom && !isMobileRegularRecom}
                                            handleAssignImages={handleAssignImages}
                                        />
                                    </>
                                ) : (
                                    <div className="no-data">
                                        <h3>Images not Available. Please Assign/Upload New Images</h3>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderImageModal()}
            {renderMasterImageModal()}
            {renderUsedImageWarning()}
            {renderSingleImageEditModal()}
            {renderConfirmationModal()}
            {renderImageForm()}
            {renderDeleteConfirmationModal()}
        </LoadingOverlay>
    );
};

export default InfoImages;
